import React from 'react';
import { NavigationButtons } from '@features/onboarding/components/shared/ui/NavigationButtons';
import { useFormControls } from '@features/onboarding/hooks/useFormControls';
import { RightArrowIcon } from '@components/shared/icon/RightArrowIcon';
import { useApplicationStore } from 'src/store/application';
import { cn } from '@utils/index';

export const BottomNavigationButtons = (
  props: React.ComponentProps<typeof NavigationButtons>
) => {
  const { currentFormStep, formData, handleNextStep } = useFormControls();
  const isApplicationLoading = useApplicationStore((s) => s.isLoading);
  return (
    <div className="bg-background fixed bottom-0 left-0 w-full px-4 py-4 hidden justify-between items-center z-20 max-2xl:z-50 max-2xl:flex">
      {currentFormStep?.number === 1 ? (
        <button
          className={cn(
            'border-primary border-2 max-lg:border-none whitespace-nowrap max-lg:w-[85%] max-xs:w-[82%] max-lg:h-15 relative mt-2 shadow-xs bg-white items-center font-extrabold uppercase w-full flex justify-center rounded-full px-15 py-1.5 text-[19px] cursor-pointer text-primary md:py-3.5',
            isApplicationLoading && 'opacity-50 pointer-events-none'
          )}
          disabled={isApplicationLoading}
          onClick={() => handleNextStep(formData)}
        >
          <span>Let's Get Started!</span>
          <RightArrowIcon
            color="var(--color-primary)"
            className="absolute right-5"
          />
        </button>
      ) : (
        <NavigationButtons
          {...props}
          prevButtonClassName="h-15 text-primary bg-white border border-primary max-lg:border-none border-2 min-w-32 max-w-[320px]"
          nextButtonClassName="h-15 bg-primary text-white min-w-32 max-w-[320px]"
          prevArrowDefaultClassName="max-lg:opacity-0"
          prevArrowHoverClassName="max-lg:opacity-100"
        />
      )}
    </div>
  );
};
